export const SECRET = 'FvvuSNDAuj9AMplJ29WJ16X8kVdZnqYm3zo46OC7'
